<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" />
    <form>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费方式：</span>
        </div>
        <el-input v-model="formData.paymentMethodText" size="small" style="width: 280px" disabled/>
      </div>

            <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费金额：</span>
        </div>
        <el-input v-model="formData.money" size="small" style="width: 280px" disabled/>
      </div>

      <div class="form-line" v-if="this.formData.paymentMethod==='4'">
        <div class="textBox">
          <span class="line-text">车位号：</span>
        </div>
          <el-select
          v-model="formData.lotCode"
          filterable
          remote
          reserve-keyword
          placeholder="请选择车位号"
          size="small" style="width: 280px"
          :remote-method="parkingLotRemoteMethod"
           >
           <el-option
            v-for="item in parkingLotList"
            :key="item.code"
            :label="item.parkLotNumber"
            :value="item.code"
            >
           </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车牌号：</span>
        </div>
        <el-input v-model="formData.carNumber" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否一人多车：</span>
        </div>
        <el-switch v-model="isHaveOther" active-text="是" inactive-text="否"></el-switch>
      </div>

      <div class="form-line" v-if="isHaveOther">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">副车车牌号：</span>
        </div>
        <div style="display: flex;justify-content: flex-start;align-items: flex-start;flex-direction: column;">
          <div v-for="(item, index) in otherCarNumberList" :key="index" style="margin-bottom: 10px;">
            <el-input v-model="item.carNumber" size="small" style="width: 280px" />
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeOtherCarNumber(index)" v-if="index > 0"></i>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addOtherCarNumber(index)" v-if="index === otherCarNumberList.length - 1 && index<1"></i>
          </div>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车主姓名：</span>
        </div>
        <el-input v-model="formData.carOwnerName" size="small" style="width: 280px" />
      </div>

                  <div class="form-line">
        <div class="textBox">
          <span class="line-text">手机号：</span>
        </div>
        <el-input v-model="formData.carOwnerPhone" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">企业名称：</span>
        </div>
        <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">起始时间：</span>
        </div>
        <el-input v-model="formData.enterStartDate" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">结束时间：</span>
        </div>
        <el-input v-model="formData.enterEndDate" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input type="textarea" v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <!-- <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款时间：</span>
        </div>
          <el-date-picker
            style="width:280px"
            v-model="formData.payTime"
            type="datetime"
            placeholder="选择收款时间"
            align="right">
          </el-date-picker>
      </div> -->

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/ParkingService";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "monthly-vehicle-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "包月车辆"
        }
      ],
      mainTitle: "修改包月车辆",
      isHaveOther: false,
      otherCarNumberList: [{ carNumber: "" }],
      formData: {
        code: "",
        lotNumber: "",
        lotCode: "",
        enterStartDate: "",
        enterEndDate: "",
        carNumber: "",
        isHaveOther: "0",
        otherCarNumber: ""
      },
      parkingLotList: ""
    };
  },
  created() {
    this.formData.code = this.$route.params.id;
    this.getMonthlyVehicleByCode();
  },
  methods: {
    toMonthlyVehiclePage() {
      this.$router.push({
        name: "monthly-vehicle"
      });
    },
    getMonthlyVehicleByCode() {
      this.$axios
        .get(`${api.getMonthlyVehicleByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data.paymentMethod == "1") {
              data.paymentMethodText = "月付";
            } else if (data.paymentMethod == "2") {
              data.paymentMethodText = "季付";
            } else if (data.paymentMethod == "3") {
              data.paymentMethodText = "半年付";
            } else if (data.paymentMethod == "4") {
              data.paymentMethodText = "年付";
            }
            this.formData = data;
            console.log(this.formData);
            this.isHaveOther = this.formData.isHaveOther === "1";
            let otherCarNumberList = [];
            if (this.isHaveOther && this.formData.otherCarNumber) {
              let otherCarNumberArr = this.formData.otherCarNumber.split(",");
              otherCarNumberArr.map(v => {
                let obj = { carNumber: v };
                otherCarNumberList.push(obj);
              });
            } else {
              otherCarNumberList = [{ carNumber: "" }];
            }
            this.otherCarNumberList = otherCarNumberList;
            this.parkingLotRemoteMethod();
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    parkingLotRemoteMethod(query) {
      this.$axios
        .post(api.getFixedUnBindLot, {
          searchKey: query
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.parkingLotList = data;
            let obj = {
              code: this.formData.lotCode,
              parkLotNumber: this.formData.lotNumber
            };
            if (this.formData.lotCode) {
              this.parkingLotList.unshift(obj);
            }
          }
        })
        .catch(errorHandler("获取车位管理失败"));
    },

    addOtherCarNumber(index) {
      if (!this.otherCarNumberList[index].carNumber) {
        nError("请先输入当前副车车牌号");
        return false;
      }
      let obj = { carNumber: "" };
      this.otherCarNumberList.push(obj);
    },

    removeOtherCarNumber(index) {
      this.otherCarNumberList.splice(index, 1);
    },

    confirm() {
      if (!this.formData.carNumber) {
        nError("请输入车牌号");
        return false;
      }
      if (!this.formData.carOwnerName) {
        nError("请输入车主姓名");
        return false;
      }
      // if (!this.formData.payTime) {
      //   nError("请选择收款时间");
      //   return false;
      // }
      if (this.isHaveOther && this.otherCarNumberList[0].carNumber === "") {
        nError("请输入副车车牌号");
        return false;
      }
      let otherCarNumber = [];
      this.otherCarNumberList.map(car => {
        if (car.carNumber) {
          otherCarNumber.push(car.carNumber);
        }
      });
      this.formData.isHaveOther = this.isHaveOther ? "1" : "0";
      this.formData.otherCarNumber = otherCarNumber.join(",");
      this.$axios
        .post(api.MonthlyVehicleUpdate, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.toMonthlyVehiclePage();
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancel() {
      this.toMonthlyVehiclePage();
    }
  },
  watch: {}
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>

<style scoped lang="less">
/deep/.el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/MonthlyVehicle/MonthlyVehicleModify.vue